<template>
  <div id="form-ingreso">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">Curso Aplicado</v-toolbar-title>
        </v-toolbar>
        <v-layout>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md12>
            <!-- INICIO DATOS DE REVISION -->
            <template>
              <v-form ref="form" v-model="validacion" lazy-validation>
                <v-layout>
                  <v-flex>
                    <v-text-field
                      v-model="regionValue"
                      :error-messages="regionErrors"
                      label="Region"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.regionValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.regionValue.$touch() : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="camunaValue"
                      :error-messages="comunaErrors"
                      label="Comuna"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.camunaValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.camunaValue.$touch() : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="nivelValue"
                      :error-messages="nivelErrors"
                      label="Nivel"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.nivelValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.nivelValue.$touch() : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="tipoValue"
                      :error-messages="tipoErrors"
                      label="Tipo"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.tipoValue.$touch()"
                      @blur="tipeView == 'crear' ? $v.tipoValue.$touch() : null"
                    ></v-text-field>
                    <v-text-field
                      v-model="rbdValue"
                      :error-messages="tipoErrors"
                      label="RBD"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.rbdValue.$touch()"
                      @blur="tipeView == 'crear' ? $v.rbdValue.$touch() : null"
                    ></v-text-field>
                    <v-text-field
                      v-model="establecimientoValue"
                      :error-messages="tipoErrors"
                      label="Establecimiento"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.establecimientoValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.establecimientoValue.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-if="this.aplicado.tipoReporte === 'REPORTEC'"
                      v-model="letraValue"
                      :error-messages="tipoErrors"
                      label="Letra"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.letraValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.letraValue.$touch() : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-if="this.aplicado.tipoReporte === 'REPORTEC'"
                      v-model="codigoCursoValue"
                      :error-messages="tipoErrors"
                      label="Codigo Curso"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.codigoCursoValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.codigoCursoValue.$touch()
                          : null
                      "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md1></v-flex>
                  <v-flex>
                    <v-text-field
                      v-model="emergenteValue"
                      :error-messages="tipoErrors"
                      label="Emergente"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.emergenteValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.emergenteValue.$touch() : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="categoriaNocodigoNumCursoValue"
                      :error-messages="tipoErrors"
                      label="Categoria No codigoNum Curso"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.categoriaNocodigoNumCursoValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.categoriaNocodigoNumCursoValue.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="detalleNocodigoNumCursoValue"
                      :error-messages="tipoErrors"
                      label="Detalle No codigoNum Curso"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.detalleNocodigoNumCursoValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.detalleNocodigoNumCursoValue.$touch()
                          : null
                      "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </template>
            <!-- TERMINO DATOS DE REVISION-->
          </v-flex>
          <v-flex xs12 md1></v-flex>
        </v-layout>
        <!-- --------------------------------------------- -->
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn
            v-if="tipeView == 'crear' || tipeView == 'modifica'"
            :loading="loading"
            color="primary"
            @click="save()"
          >
            Guardar
            <v-icon right dark>save</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "FormIngreso",
  components: {
    AlertEmpty,
  },
  mixins: [misMixins, validationMixin],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      loading: false,
      alertaRecibidos: false,
      dialog: false,
      visibleNew: false,
      userlogged: "",
      regionValue: "",
      camunaValue: "",
      nivelValue: "",
      tipoValue: "",
      rbdValue: "",
      establecimientoValue: "",
      letraValue: "",
      codigoCursoValue: "",
      emergenteValue: "",
      categoriaNocodigoNumCursoValue: "",
      detalleNocodigoNumCursoValue: "",
      vNumeroRegistroValue: "",
      idAplicado: "",
      aplicado: [],
    };
  },

  validations: {},

  created() {
    this.tipeCenter = this.$store.getters.subTabSelectedStored;
    this.titleView = this.$route.params.titleView;
    this.idContrato = this.$store.getters.contratoStored;

    if (this.tipeView === undefined) {
      this.tipeView = this.$route.params.tipeView;
    }
    if (this.tipeView == "consulta") {
      this.idAplicado = this.$route.params.idAplicado;
      this.userlogged = this.$store.getters.userLogged.tipo;
      this.loadData();
    }
    if (this.tipeView == "crear") {
    }
    if (this.userlogged == "PROVEEDOR") {
      this.visibleNew = true;
    } else {
      this.visibleNew = false;
    }
  },
  mounted() {},
  computed: {},
  methods: {
    async loadData() {
      this.aplicado = await this.loadAplicadosData();
      this.regionValue = this.aplicado.idRegion.nombre;
      this.camunaValue = this.aplicado.idComuna.nombre;
      this.nivelValue = this.aplicado.idNivel.descripcion;
      this.tipoValue = this.aplicado.idTipocodigoNum.descripcion;
      this.rbdValue = this.aplicado.rbd;
      this.establecimientoValue = this.aplicado.establecimiento;
      this.letraValue = this.aplicado.letra;
      this.codigoCursoValue = this.aplicado.codigoCurso;
      if (this.aplicado.emergente == 1) {
        this.emergenteValue = "MECANIZADO";
      }
      if (this.aplicado.emergente == 2) {
        this.emergenteValue = "EMERGENTE";
      }
      this.categoriaNocodigoNumCursoValue =
        this.aplicado.categoriaNoAplicadaId.descripcion;
      this.detalleNocodigoNumCursoValue = this.aplicado.detalleNocodigoNum;
    },

    async loadAplicadosData() {
      var that = this;
      return await axios
        .get(
          "/reporte6BC/getReporteBCById/" +
            this.idAplicado +
            "/" +
            this.idContrato
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    save() {
      if (this.tipeView == "crear") {
        this.loading = true;
        this.saveCronograma();
        this.loading = false;
      } else {
        this.loading = true;
        this.editRevision();
        this.loading = false;
      }
    },

    saveCronograma() {
      this.loading = true;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        // -----
        idContrato: idContrato,
        region: this.regionValue,
        caId: this.centroOrigenValue,
        coId: this.centroDestinoValue,
        idMaterial: this.materialValue,
        mat_complementario: this.materialComplementario,
        mat_codigoNum: this.materialcodigoNum,
        fecha_movimiento: this.formatoFecha(this.fechaTraspaso),
        hora_movimiento: this.horaAgendaValue,
        nivel: this.nivelValue,
        codCurso: this.codCurso,
      };
      axios
        .post("/traspasoCaCo/AgendarCronograma", this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.volver();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },

    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesocodigoNum",
        });
      }, 1000);
    },
  },
};
</script>
